import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTicketContext } from './TicketContext';
import { mobileTicket } from '../../../../api';

export const useGetTicketSignature = ({ signatureUrl }) => {
  const { entityRef } = useParams();
  const { ticket } = useTicketContext();

  const hasSignatureUrl = signatureUrl !== null && signatureUrl !== undefined && signatureUrl !== '';
  const isDataUrl = hasSignatureUrl && String(signatureUrl).includes('data:image/png;base64');
  const isQueryEnabled = hasSignatureUrl && !isDataUrl;
  const signatureType = hasSignatureUrl ? String(signatureUrl).split('/').pop() : null;

  const { data, isLoading } = useQuery({
    queryKey: ['ticketSignature', entityRef, ticket?.crn, signatureType],
    queryFn: () => mobileTicket.getTicketSignature({ entityRef, ticketRef: ticket?.crn, signatureType }),
    enabled: isQueryEnabled && signatureType !== null,
  });

  const image = useMemo(() => {
    if (!hasSignatureUrl) {
      return null;
    }

    if (isDataUrl) {
      return signatureUrl;
    }

    if (data?.image) {
      return `data:image/png;base64,${data.image}`;
    }

    return null;
  }, [hasSignatureUrl, isDataUrl, signatureUrl, data?.image]);

  return { image, isLoading: isQueryEnabled ? isLoading : false };
};
